import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FamlaServices } from '../services';
import { InputForm } from './';

type Props = {
    accessToken: string;
    initialPhone: string | null;
    onSaved?: (phone: string | null) => void;
};

const UserPhoneEditModal = ({ accessToken, initialPhone, onSaved }: Props) => {
    const { t } = useTranslation();
    const [phone, setPhone] = useState(initialPhone || '');
    const [saving, setSaving] = useState(false);
    const [message, setMessage] = useState('');

    const handleSave = async () => {
        setSaving(true);
        setMessage('');
        try {
            const data = await FamlaServices('api_host', '/users/', 'PUT', {
                phone_number: phone.trim() || null,
                lang: 'english',
                updated_at: new Date().toISOString(),
            }, accessToken);
            if (data.status === 200) {
                setMessage(t('navigation.phoneUpdated'));
                onSaved?.(phone.trim() || null);
            } else {
                setMessage(t('navigation.anErrorOccurred'));
            }
        } catch {
            setMessage(t('navigation.anErrorOccurred'));
        }
        setSaving(false);
    };

    return (
        <div className="modal fade" id="editUserPhone" tabIndex={-1} aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content bg-dark">
                    <div className="modal-header border-0">
                        <h5 className="modal-title text-white">{t('form.createCompany.phoneNumber')}</h5>
                        <button type="button" className="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close" />
                    </div>
                    <div className="modal-body">
                        {message && <div className="alert alert-info">{message}</div>}
                        <InputForm
                            inputType="tel"
                            inputLabel={t('navigation.whatsappPhone')}
                            inputName="user-phone"
                            inputValue={phone}
                            onChange={(e) => setPhone((e.target as HTMLInputElement).value)}
                            inputClass="bg-dark text-light"
                        />
                    </div>
                    <div className="modal-footer border-0">
                        <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">{t('words.cancel')}</button>
                        <button type="button" className="btn btn-primary" disabled={saving} onClick={handleSave}>
                            {t('words.save')}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default UserPhoneEditModal;
